import { render, staticRenderFns } from "./WorkflowPublished.vue?vue&type=template&id=4c60de41&scoped=true"
import script from "./WorkflowPublished.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkflowPublished.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./WorkflowPublished.vue?vue&type=style&index=0&id=4c60de41&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c60de41",
  null
  
)

export default component.exports